import { Formatter } from "incur";
import cli from "./cli";
import { getActiveProfile } from "./auth/profiles";
import { buildGroupedHelp } from "./lib/grouped-help";
import { API_VERSION_DATE } from "./lib/http";
import { colorizeOutput, shouldColorize } from "./lib/colorize-output";
import { initAuditLog, setAuditArgv } from "./lib/audit-log";
import { scheduleUpdateNotice } from "./lib/update/check";
import {
	hasLegacyAccountId,
	promptForMissingParams,
} from "./journey/missing-params";
import pkg from "../package.json" with { type: "json" };

const argv = process.argv.slice(2);
initAuditLog(argv, pkg.version);

function requestedFormat(argv: string[]): Formatter.Format {
	if (argv.includes("--json")) return "json";
	const formatIndex = argv.indexOf("--format");
	const explicit =
		formatIndex === -1
			? argv.find((token) => token.startsWith("--format="))?.slice(9)
			: argv[formatIndex + 1];
	return explicit === "json" ||
		explicit === "yaml" ||
		explicit === "md" ||
		explicit === "jsonl"
		? explicit
		: "toon";
}

if (hasLegacyAccountId(argv)) {
	const error = {
		code: "INVALID_ACCOUNT_ID_ARGUMENT",
		message:
			"Account IDs cannot be passed positionally. Use `--account_id <account_id>`.",
	};
	const format = requestedFormat(argv);
	const output =
		process.stdout.isTTY && format === "toon"
			? error.message
			: Formatter.format(error, format);
	process.stdout.write(`${output}\n`);
	process.exit(1);
}

const activeProfile = getActiveProfile();
scheduleUpdateNotice(argv, pkg.version);

async function serve(argv: string[]) {
	setAuditArgv(argv);
	if (shouldColorize(argv)) {
		await cli.serve(argv, {
			stdout: (s) => process.stdout.write(colorizeOutput(s)),
		});
	} else {
		await cli.serve(argv);
	}
}

if (argv.length === 1 && argv[0] === "--version") {
	process.stdout.write(`${pkg.version}\nAPI version: ${API_VERSION_DATE}\n`);
	process.exit(0);
} else if (
	argv.length === 0 &&
	!process.env.WHOP_API_KEY &&
	(!activeProfile || !activeProfile.accountId)
) {
	await serve(["quickstart"]);
} else if (argv.length === 0 || (argv.length === 1 && argv[0] === "--help")) {
	process.stdout.write(
		buildGroupedHelp(
			pkg.version,
			API_VERSION_DATE,
			cli.description ?? "Build and manage Whop apps from your terminal.",
		) + "\n",
	);
	process.exit(0);
} else {
	await serve(await promptForMissingParams(argv));
}
